import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

import { showSuccessSnackbar } from 'modules/snackbar';
import { makeHeadData } from 'lib/commonLib';

import NewTableContainer from 'components/molecules/NewTable';
import Modal from 'components/organisms/NewModal';

const useStyles = makeStyles((theme) => ({
  textFieldRoot: {
    '& textarea': {
      minHeight: 200,
      maxHeight: 500,
    },
  },
}));

const JsonUpLoad = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { propsData, dataReqPromise, propsHeadCells, customized } = props;
  let initParams = {
    sort: 'desc',
    order: 'ID',
  };
  const [params, setParams] = useState(initParams);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState('');
  const [showTable, setShowTable] = useState(false);
  const [tableList, setTableList] = useState([]);

  useEffect(() => {
    if (propsData.open) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [propsData]);

  useEffect(() => {
    if (tableList.length > 0) {
      setShowTable(true);
    } else {
      setShowTable(false);
    }
  }, [tableList]);

  const handleModalClose = () => {
    setOpen(false);
    setValue('');
    setTableList([]);
    setShowTable(false);
  };

  const handleConverter = () => {
    const valueArray = value.split('\n');
    let resultArray = [];
    for (let i = 0; i < valueArray.length; i++) {
      const rowValue = valueArray[i].split(',');
      if (rowValue.length === 9) {
        let newJson = {};

        for (let i = 0; i < rowValue.length; i++) {
          if (i === 0) {
            newJson['id'] = rowValue[i];
          } else if (i === 1) {
            newJson['code'] = rowValue[i];
          } else if (i === 2) {
            newJson['name'] = rowValue[i];
          } else if (i === 3) {
            newJson['cate'] = rowValue[i];
          } else if (i === 4) {
            newJson['url'] = rowValue[i];
          } else if (i === 5) {
            newJson['path'] = rowValue[i];
          } else if (i === 6) {
            newJson['price'] = rowValue[i];
          } else if (i === 7) {
            newJson['dcPrice'] = rowValue[i];
          } else if (i === 8) {
            newJson['device'] = rowValue[i];
          }
        }
        resultArray = [...resultArray, newJson];
        // resultArray.push(newJson);
      } else if (rowValue.length === 1) {
      } else {
        resultArray = [];
        handleClickSnackbar({
          message: t('등록되지 않았습니다.'),
          option: {
            type: 'error',
          },
        });
        break;
      }
    }
    setTableList(resultArray);
  };
  const handleSubmit = () => {
    let newString = '';
    for (let i = 0; i < tableList.length; i++) {
      for (let itemKey in tableList[i]) {
        newString =
          newString +
          'products[' +
          i +
          '][' +
          itemKey +
          ']=' +
          (itemKey === 'code' ||
          itemKey === 'name' ||
          itemKey === 'url' ||
          itemKey === 'path' ||
          itemKey === 'cate'
            ? encodeURIComponent(tableList[i][itemKey])
            : tableList[i][itemKey]) +
          '&';
      }
    }
    dataReqPromise(newString.substr(0, newString.length - 1))
      .then((response) => {
        handleClickSnackbar({
          message: response.data.message,
          option: {
            type: 'success',
          },
        });
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error,
          option: {
            type: 'error',
          },
        });
      })
      .finally(() => {
        handleModalClose();
      });
  };

  const handleOnChange = (e) => {
    setValue(e.target.value);
  };

  const getParams = (newParams) => {
    if (JSON.stringify(initParams) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  /**
   * 스낵바 리덕스 값을 변경해주는 함수
   * @type {(...args: any[]) => any}
   */
  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <Modal
        open={propsData.open && open}
        headerTitle={
          !!propsData.headerTitle
            ? propsData.headerTitle
            : t('일반상품 수집 데이터 일괄 등록')
        }
        handleClose={showTable ? () => setShowTable(false) : handleModalClose}
        cancelBtnTitle={showTable ? t('취소') : t('닫기')}
        confirmBtnTitle={showTable ? t('최종확인') : t('저장')}
        confirmOnClick={showTable ? handleSubmit : handleConverter}
        // useForm={modal.type !== 'delete'}
        style={{ minWidth: 1000, minHeight: 300 }}
      >
        {showTable ? (
          <NewTableContainer
            params={params}
            getParam={getParams}
            customized={customized}
            useTotal={false}
            useExcel={false}
            useCustomTable
            propsList={tableList}
            propsHeadCells={makeHeadData(propsHeadCells)}
            useFetch={false}
            useFullScreen={false}
            useSearch={false}
          />
        ) : (
          <TextField
            id="JsonUpLoad"
            autoFocus
            defaultValue={value}
            multiline
            required
            placeholder={
              '입력할 키워드를 다음과 같이 한줄에 한상품씩 순차적으로 직접 입력해주세요.\n엑셀을 이용하여 정리하고 파일 확장자를 csv로 저장한 후 해당파일을\n메모장으로 열어 복사+붙여넣기하면 훨씬 편리하게 이용이 가능합니다. \n\n등록형태 : [계정ID,상품코드(pcode),상품명,카테고리,URL,상품이미지URL,가격,할인가격,디바이스(PC,MO)]'
            }
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            variant="outlined"
            classes={{ root: classes.textFieldRoot }}
            onBlur={handleOnChange}
          />
        )}
      </Modal>
    </>
  );
};

export default JsonUpLoad;
